angular.module('autoremind.templates')
    .directive('previewImage', ['templateService', 'FileUploader', '$timeout', 'dialogs', '$rootScope',
    function (templateService, FileUploader, $timeout, dialogs, $rootScope) {
        return {
            restrict: 'E',
            templateUrl: 'app/common/messages/preview-image.html',
            link: function (scope, elem, attr) {
            }
        };
    }]);
//# sourceMappingURL=preview-image.directive.js.map